import { DeploymentUnitOutlined } from "@ant-design/icons";
import { Space, Typography, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import { MODEL_KEY } from "@/modules/model";
import ModelIcon from "@/modules/model-icon";
import { ModelLink } from "@/modules/model-link";

const SectionNameCell = ({ name, asset, flags }) => {
  const { t } = useTranslation();

  const loopOnChildren = flags?.loopOnChildren;
  const assetType = asset?.assetType;
  return (
    <Space orientation="vertical">
      {loopOnChildren && asset && <ModelLink model="asset" item={asset} />}
      <Space wrap size={20}>
        {loopOnChildren ? (
          <Tooltip
            title={`${t(
              "interventionTemplate:form.flags.loopOnChildren"
            )} : ${name}`}
          >
            <Space wrap size={3}>
              <Typography.Text
                type="secondary"
                ellipsis={true}
                style={{ maxWidth: "220px" }}
              >
                <DeploymentUnitOutlined /> {name}
              </Typography.Text>
            </Space>
          </Tooltip>
        ) : (
          <Space wrap size={3}>
            <Typography.Text ellipsis={true} style={{ maxWidth: "220px" }}>
              {name}
            </Typography.Text>
          </Space>
        )}
        {loopOnChildren && assetType && (
          <Tooltip title={`${t("global:assetType")} : ${assetType.name}`}>
            <Typography.Text
              type="secondary"
              ellipsis={true}
              style={{ maxWidth: "150px" }}
            >
              <ModelIcon model={MODEL_KEY.ASSETTYPE} /> {assetType.name}
            </Typography.Text>
          </Tooltip>
        )}
      </Space>
    </Space>
  );
};

export default SectionNameCell;
